module.exports = __webpack_public_path__ + "img/image_5.8f4800c7.png";